/* A Node Js Library to get cartoons style avatars */

module.exports = require('./lib/cartoon-avatar');